import * as React from 'react';
import {Enumeration} from '../Api/EnumerationTypes';

export interface IEnum {
    worksLocationTypes: Enumeration[];
    phaseTypes: Enumeration[];
    tmTypes: Enumeration[];
    fwClosures: Enumeration[];
    permitStates: Enumeration[];
    noticeStates: Enumeration[];
    noticeFileTypes: Enumeration[];
    permitTypes: Enumeration[];
    roadTypes: Enumeration[];
    cancelReasons: Enumeration[];
    subResources: Enumeration[];
    regStatuses: Enumeration[];
    sensitiveHours: Enumeration[];
}

export type EnumType = {
    enums: IEnum | null;
    setEnums: (enums: IEnum) => void;
}

export const EnumContext = React.createContext<EnumType> ({
    enums: null,
    setEnums: (enums: IEnum) => null
});

export default EnumContext;
